import { useEffect, useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';

import styles from './Editar.module.css';
import getUnidades from '../../../../api/getUnidades';
import { institutionSelect } from '../../../../helpers/unidades';
import getUserById from '../../../../api/getUserById';
import { phoneMask, matriculaMask } from '../../../../helpers/masks';
import editarUsuario from '../../../../api/editarUsuario';
import { decrypt, decryptArray } from '../../../../helpers/cryptography';
import logoFesaude2 from '../../../../assets/img/fesaude-logo2.png';

const Editar = () => {
  const userRef = useRef(null);
  const respRef = useRef(null);
  const adminRef = useRef(null);
  const consultaRef = useRef(null);
  const vrRef = useRef(null);
  const vestuarioRef = useRef(null);
  const monitorRef = useRef(null);
  const ouvidoriaRef = useRef(null);
  const ouvidoriaConsultaRef = useRef(null);
  const cipaRef = useRef(null);
  const capsAdminRef = useRef(null);
  const capsSupervisorRef = useRef(null);
  const capsOperadorRef = useRef(null);
  const capsConsultaRef = useRef(null);
  const capsDocsRef = useRef(null);
  const capsDocsEspRef = useRef(null);
  const todosCapsConsultaRef = useRef(null);
  const mdiRef = useRef(null);
  const mdiAdminRef = useRef(null);
  const erpRef = useRef(null);
  const pesquisaRef = useRef(null);
  const inscricaoAdminRef = useRef(null);
  const reducaoDeDanosRef = useRef(null);
  const reducaoConsultaRef = useRef(null);
  const docsDasRef = useRef(null);
  const docsDitiRef = useRef(null);
  const docsDtecRef = useRef(null);
  const docsDafRef = useRef(null);
  const docsDgRef = useRef(null);
  const cecoAdminRef = useRef(null);
  const cecoOperadorRef = useRef(null);
  const gestorRef = useRef(null);
  const ativAdminRef = useRef(null);
  const ativOperadorRef = useRef(null);
  const ativConsultaRef = useRef(null);
  const leitosRef = useRef(null);
  const leitosUaiRef = useRef(null);
  const leitosUaaRef = useRef(null);
  const leitosCapsAdRef = useRef(null);
  const todosLeitosConsultaRef = useRef(null);
  const conselhoCuradorRef = useRef(null);
  const treinamentoRef = useRef(null);
  const cecRef = useRef(null);
  const suprimentosAdminRef = useRef(null);
  const suprimentosConsultaRef = useRef(null);
  const suprimentosOperadorRef = useRef(null);
  const insumosOdontoRef = useRef(null);
  const insumosPmfRef = useRef(null);
  const insumosRapsRef = useRef(null);
  const insumosSrtRef = useRef(null);
  const medicamentosRef = useRef(null);
  
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [roles, setRoles] = useState({
    USER: false,
    RESP: false,
    ADMIN: false,
    CONSULTA: false,
    VR: false,
    VESTUARIO: false,
    MONITOR: false,
    OUVIDORIA: false,
    OUVIDORIA_CONSULTA: false,
    CIPA: false,
    CAPS_ADMIN: false,
    CAPS_SUPERVISOR: false,
    CAPS_OPERADOR: false,
    CAPS_CONSULTA: false,
    CAPS_DOCS: false,
    CAPS_DOCS_ESP: false,
    TODOS_CAPS_CONSULTA: false,
    MDI: false,
    MDI_ADMIN: false,
    ERP: false,
    PESQUISA: false,
    INSCRICAO_ADMIN: false,
    REDUCAO_DE_DANOS: false,
    RD_CONSULTA: false,
    DOCS_DAS: false,
    DOCS_DITI: false,
    DOCS_DTEC: false,
    DOCS_DAF: false,
    DOCS_DG: false,
    CECO_ADMIN: false,
    CECO_OPERADOR: false,
    GESTOR: false,
    ATIV_ADMIN: false,
    ATIV_OPERADOR: false,
    ATIV_CONSULTA: false,
    LEITOS: false,
    LEITOS_UAI: false,
    LEITOS_UAA: false,
    LEITOS_CAPS_AD: false,
    TODOS_LEITOS_CONSULTA: false,
    CONSELHO_CURADOR: false,
    TREINAMENTO: false,
    CEC: false,
    SUPRIMENTOS_ADMIN: false,
    SUPRIMENTOS_CONSULTA: false,
    SUPRIMENTOS_OPERADOR: false,
    INSUMOS_ODONTO: false,
    INSUMOS_PMF: false,
    INSUMOS_RAPS: false,
    INSUMOS_SRT: false,
    MEDICAMENTOS: false,
  });

  const [unidades, setUnidades] = useState([]);

  const initialValues = {
    _id: '',
    name: '',
    email: '',
    phone: '',
    unit: '',
    institution: '',
    admissionDate: '',
    registration: ''
  };

  const roleGroups = [
    {
      group: 'USER',
      roles: [
        {
          name: 'USER',
          ref: userRef,
        }, 
        {
          name: 'RESP',
          ref: respRef,
        }, 
        {
          name: 'ADMIN',
          ref: adminRef,
        }, 
        {
          name: 'CONSULTA',
          ref: consultaRef,
        }, 
      ]
    },
    {
      group: 'DOCS',
      roles: [
        {
          name: 'DOCS_DAS',
          ref: docsDasRef,
        },
        {
          name: 'DOCS_DITI',
          ref: docsDitiRef,
        },
        {
          name: 'DOCS_DTEC',
          ref: docsDtecRef,
        },
        {
          name: 'DOCS_DAF',
          ref: docsDafRef,
        },
        {
          name: 'DOCS_DG',
          ref: docsDgRef,
        },
      ]
    },
    {
      group: 'GESTÃO',
      subgroups: [
        {
          title: 'OUVIDORIA',
          roles: [
            {
              name: 'OUVIDORIA',
              ref: ouvidoriaRef,
            },
            {
              name: 'OUVIDORIA_CONSULTA',
              ref: ouvidoriaConsultaRef,
            },
          ]
        },
        {
          title: 'MDI',
          roles: [
            {
              name: 'MDI',
              ref: mdiRef,
            },
            {
              name: 'MDI_ADMIN',
              ref: mdiAdminRef,
            },
          ]
        },
        {
          title: 'AE',
          roles: [
            {
              name: 'ATIV_ADMIN',
              ref: ativAdminRef,
            },
            {
              name: 'ATIV_OPERADOR',
              ref: ativOperadorRef,
            },
            {
              name: 'ATIV_CONSULTA',
              ref: ativConsultaRef,
            },
          ]
        },
        {
          title: 'OUTROS',
          roles: [
            {
              name: 'PESQUISA',
              ref: pesquisaRef,
            },
            {
              name: 'VESTUARIO',
              ref: vestuarioRef,
            },
            {
              name: 'CIPA',
              ref: cipaRef,
            },
            {
              name: 'CONSELHO_CURADOR',
              ref: conselhoCuradorRef,
            },
            {
              name: 'INSCRICAO_ADMIN',
              ref: inscricaoAdminRef,
            },
            {
              name: 'TREINAMENTO',
              ref: treinamentoRef,
            },
            {
              name: 'CEC',
              ref: cecRef,
            }
          ]
        },
      ]
    },
    {
      group: 'RAPS',
      subgroups: [
        {
          title: 'CAPS',
          roles: [
            {
              name: 'CAPS_ADMIN',
              ref: capsAdminRef,
            },
            {
              name: 'CAPS_SUPERVISOR',
              ref: capsSupervisorRef,
            },
            {
              name: 'CAPS_OPERADOR',
              ref: capsOperadorRef,
            },
            {
              name: 'CAPS_CONSULTA',
              ref: capsConsultaRef,
            },
            {
              name: 'CAPS_DOCS',
              ref: capsDocsRef,
            },
            {
              name: 'CAPS_DOCS_ESP',
              ref: capsDocsEspRef,
            },
            {
              name: 'TODOS_CAPS_CONSULTA',
              ref: todosCapsConsultaRef,
            },
          ]
        },
        {
          title: 'RD',
          roles: [
            {
              name: 'REDUCAO_DE_DANOS',
              ref: reducaoDeDanosRef,
            },
            {
              name: 'RD_CONSULTA',
              ref: reducaoConsultaRef,
            },
          ]
        },
        {
          title: 'CECO',
          roles: [
            {
              name: 'CECO_ADMIN',
              ref: cecoAdminRef,
            },
            {
              name: 'CECO_OPERADOR',
              ref: cecoOperadorRef,
            },
          ]
        },
        {
          title: 'LEITOS',
          roles: [
            {
              name: 'LEITOS',
              ref: leitosRef,
            },
            {
              name: 'LEITOS_UAI',
              ref: leitosUaiRef,
            },
            {
              name: 'LEITOS_UAA',
              ref: leitosUaaRef,
            },
            {
              name: 'LEITOS_CAPS_AD',
              ref: leitosCapsAdRef,
            },
            {
              name: 'TODOS_LEITOS_CONSULTA',
              ref: todosLeitosConsultaRef,
            },
          ]
        },
      ]
    },
    {
      group: 'SUPRIMENTOS',
      subgroups: [
        {
          title: 'MENU',
          roles: [
            {
              name: 'SUPRIMENTOS_ADMIN',
              ref: suprimentosAdminRef
            },
            {
              name: 'SUPRIMENTOS_CONSULTA',
              ref: suprimentosConsultaRef
            },
            {
              name: 'SUPRIMENTOS_OPERADOR',
              ref: suprimentosOperadorRef
            },
          ]
        },
        {
          title: 'REQUISIÇÃO',
          roles: [
            {
              name: 'INSUMOS_ODONTO',
              ref: insumosOdontoRef,
            },
            {
              name: 'INSUMOS_PMF',
              ref: insumosPmfRef,
            },
            {
              name: 'INSUMOS_RAPS',
              ref: insumosRapsRef,
            },
            {
              name: 'INSUMOS_SRT',
              ref: insumosSrtRef,
            },
          ]
        },
        {
          title: 'MEDICAMENTOS',
          roles: [
            {
              name: 'MEDICAMENTOS',
              ref: medicamentosRef,
            },
          ]
        },
      ]
    },
    {
      group: 'OUTROS',
      roles: [
        {
          name: 'GESTOR',
          ref: gestorRef,
        },
        {
          name: 'ERP',
          ref: erpRef,
        },
        {
          name: 'VR',
          ref: vrRef,
        },
        {
          name: 'MONITOR',
          ref: monitorRef,
        },
      ]
    }
  ]

  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    const fetchUnidades = async () => {
      const response = await getUnidades('sisged');

      setUnidades(response);
    };

    fetchUnidades();
  }, []);

  useEffect(() => {
    const fetchUsuario = async () => {
      const response = await getUserById(id);
      const { _id, name, email, phone, unit, institution, admissionDate, registration, roles } = response;

      setValues({
        _id,
        name: name ? decrypt(name) : '',
        email: email ? decrypt(email) : '',
        phone: phone ? decrypt(phone) : '',
        unit: unit ? decrypt(unit) : '',
        institution: institution ?? '',
        admissionDate: admissionDate ? admissionDate.split('T')[0] : '',
        registration: registration ? decrypt(registration) : ''
      });

      const rolesArray = decryptArray(roles);

      setRoles({
        USER: rolesArray.includes('USER') ? true : false,
        RESP: rolesArray.includes('RESP') ? true : false,
        ADMIN: rolesArray.includes('ADMIN') ? true : false,
        CONSULTA: rolesArray.includes('CONSULTA') ? true : false,
        VR: rolesArray.includes('VR') ? true : false,
        VESTUARIO: rolesArray.includes('VESTUARIO') ? true : false,
        MONITOR: rolesArray.includes('MONITOR') ? true : false,
        OUVIDORIA: rolesArray.includes('OUVIDORIA') ? true : false,
        OUVIDORIA_CONSULTA: rolesArray.includes('OUVIDORIA_CONSULTA') ? true : false,
        CIPA: rolesArray.includes('CIPA') ? true : false,
        CAPS_ADMIN: rolesArray.includes('CAPS_ADMIN') ? true : false,
        CAPS_SUPERVISOR: rolesArray.includes('CAPS_SUPERVISOR') ? true : false,
        CAPS_OPERADOR: rolesArray.includes('CAPS_OPERADOR') ? true : false,
        CAPS_CONSULTA: rolesArray.includes('CAPS_CONSULTA') ? true : false,
        CAPS_DOCS: rolesArray.includes('CAPS_DOCS') ? true : false,
        CAPS_DOCS_ESP: rolesArray.includes('CAPS_DOCS_ESP') ? true : false,
        TODOS_CAPS_CONSULTA: rolesArray.includes('TODOS_CAPS_CONSULTA') ? true : false,
        MDI: rolesArray.includes('MDI') ? true : false,
        MDI_ADMIN: rolesArray.includes('MDI_ADMIN') ? true : false,
        ERP: rolesArray.includes('ERP') ? true : false,
        PESQUISA: rolesArray.includes('PESQUISA') ? true : false,
        INSCRICAO_ADMIN: rolesArray.includes('INSCRICAO_ADMIN') ? true : false,
        REDUCAO_DE_DANOS: rolesArray.includes('REDUCAO_DE_DANOS') ? true : false,
        RD_CONSULTA: rolesArray.includes('RD_CONSULTA') ? true : false,
        DOCS_DAS: rolesArray.includes('DOCS_DAS') ? true : false,
        DOCS_DITI: rolesArray.includes('DOCS_DITI') ? true : false,
        DOCS_DTEC: rolesArray.includes('DOCS_DTEC') ? true : false,
        DOCS_DAF: rolesArray.includes('DOCS_DAF') ? true : false,
        DOCS_DG: rolesArray.includes('DOCS_DG') ? true : false,
        CECO_ADMIN: rolesArray.includes('CECO_ADMIN') ? true : false,
        CECO_OPERADOR: rolesArray.includes('CECO_OPERADOR') ? true : false,
        GESTOR: rolesArray.includes('GESTOR') ? true : false,
        ATIV_ADMIN: rolesArray.includes('ATIV_ADMIN')? true : false,
        ATIV_OPERADOR: rolesArray.includes('ATIV_OPERADOR')? true : false,
        ATIV_CONSULTA: rolesArray.includes('ATIV_CONSULTA')? true : false,
        LEITOS: rolesArray.includes('LEITOS') ? true : false,
        LEITOS_UAI: rolesArray.includes('LEITOS_UAI') ? true : false,
        LEITOS_UAA: rolesArray.includes('LEITOS_UAA') ? true : false,
        LEITOS_CAPS_AD: rolesArray.includes('LEITOS_CAPS_AD') ? true : false,
        TODOS_LEITOS_CONSULTA: rolesArray.includes('TODOS_LEITOS_CONSULTA') ? true : false,
        CONSELHO_CURADOR: rolesArray.includes('CONSELHO_CURADOR') ? true : false,
        TREINAMENTO: rolesArray.includes('TREINAMENTO') ? true : false,
        CEC: rolesArray.includes('CEC') ? true : false,
        SUPRIMENTOS_ADMIN: rolesArray.includes('SUPRIMENTOS_ADMIN') ? true : false,
        SUPRIMENTOS_CONSULTA: rolesArray.includes('SUPRIMENTOS_CONSULTA') ? true : false,
        SUPRIMENTOS_OPERADOR: rolesArray.includes('SUPRIMENTOS_OPERADOR') ? true : false,
        INSUMOS_ODONTO: rolesArray.includes('INSUMOS_ODONTO') ? true : false,
        INSUMOS_PMF: rolesArray.includes('INSUMOS_PMF') ? true : false,
        INSUMOS_RAPS: rolesArray.includes('INSUMOS_RAPS') ? true : false,
        INSUMOS_SRT: rolesArray.includes('INSUMOS_SRT') ? true : false,
        MEDICAMENTOS: rolesArray.includes('MEDICAMENTOS') ? true : false,
      });
    };

    fetchUsuario();
  }, [id]);

  useEffect(() => {
    if (roles.USER) {
      userRef.current.checked = true;
    }
    
    if (roles.CONSULTA) {
      consultaRef.current.checked = true;
    }
    
    if (roles.RESP) {
      respRef.current.checked = true;
    }
    
    if (roles.ADMIN) {
      adminRef.current.checked = true;
    }
    
    if (roles.VR) {
      vrRef.current.checked = true;
    }
    
    if (roles.VESTUARIO) {
      vestuarioRef.current.checked = true;
    }
    
    if (roles.MONITOR) {
      monitorRef.current.checked = true;
    }
    
    if (roles.OUVIDORIA) {
      ouvidoriaRef.current.checked = true;
    }
    
    if (roles.OUVIDORIA_CONSULTA) {
      ouvidoriaConsultaRef.current.checked = true;
    }
    
    if (roles.CIPA) {
      cipaRef.current.checked = true;
    }

    if (roles.CAPS_ADMIN) {
      capsAdminRef.current.checked = true;
    }
    
    if (roles.CAPS_SUPERVISOR) {
      capsSupervisorRef.current.checked = true;
    }
    
    if (roles.CAPS_OPERADOR) {
      capsOperadorRef.current.checked = true;
    }
    
    if (roles.CAPS_CONSULTA) {
      capsConsultaRef.current.checked = true;
    }
    
    if (roles.CAPS_DOCS) {
      capsDocsRef.current.checked = true;
    }
    
    if (roles.CAPS_DOCS_ESP) {
      capsDocsEspRef.current.checked = true;
    }

    if (roles.TODOS_CAPS_CONSULTA) {
      todosCapsConsultaRef.current.checked = true;
    }

    if (roles.MDI) {
      mdiRef.current.checked = true;
    }
    
    if (roles.MDI_ADMIN) {
      mdiAdminRef.current.checked = true;
    }
    
    if (roles.ERP) {
      erpRef.current.checked = true;
    }
    
    if (roles.PESQUISA) {
      pesquisaRef.current.checked = true;
    }
    
    if (roles.INSCRICAO_ADMIN) {
      inscricaoAdminRef.current.checked = true;
    }
    
    if (roles.REDUCAO_DE_DANOS) {
      reducaoDeDanosRef.current.checked = true;
    }

    if (roles.RD_CONSULTA) {
      reducaoConsultaRef.current.checked = true;
    }
    
    if (roles.DOCS_DAS) {
      docsDasRef.current.checked = true;
    }
    
    if (roles.DOCS_DITI) {
      docsDitiRef.current.checked = true;
    }
    
    if (roles.DOCS_DTEC) {
      docsDtecRef.current.checked = true;
    }
    
    if (roles.DOCS_DAF) {
      docsDafRef.current.checked = true;
    }
    
    if (roles.DOCS_DG) {
      docsDgRef.current.checked = true;
    }
    
    if (roles.CECO_ADMIN) {
      cecoAdminRef.current.checked = true;
    }
    
    if (roles.CECO_OPERADOR) {
      cecoOperadorRef.current.checked = true;
    }
    
    if (roles.GESTOR) {
      gestorRef.current.checked = true;
    }

    if (roles.ATIV_ADMIN) {
      ativAdminRef.current.checked = true;
    }

    if (roles.ATIV_OPERADOR) {
      ativOperadorRef.current.checked = true;
    }

    if (roles.ATIV_CONSULTA) {
      ativConsultaRef.current.checked = true;
    }
    
    if (roles.LEITOS) {
      leitosRef.current.checked = true;
    }

    if (roles.LEITOS_UAI) {
      leitosUaiRef.current.checked = true;
    }

    if (roles.LEITOS_UAA) {
      leitosUaaRef.current.checked = true;
    }

    if (roles.LEITOS_CAPS_AD) {
      leitosCapsAdRef.current.checked = true;
    }

    if (roles.TODOS_LEITOS_CONSULTA) {
      todosLeitosConsultaRef.current.checked = true;
    }

    if (roles.CONSELHO_CURADOR) {
      conselhoCuradorRef.current.checked = true;
    }

    if (roles.TREINAMENTO) {
      treinamentoRef.current.checked = true;
    }
    
    if (roles.CEC) {
      cecRef.current.checked = true;
    }

    if (roles.SUPRIMENTOS_ADMIN) {
      suprimentosAdminRef.current.checked = true;
    }

    if (roles.SUPRIMENTOS_CONSULTA) {
      suprimentosConsultaRef.current.checked = true;
    }

    if (roles.SUPRIMENTOS_OPERADOR) {
      suprimentosOperadorRef.current.checked = true;
    }

    if (roles.INSUMOS_ODONTO) {
      insumosOdontoRef.current.checked = true;
    }

    if (roles.INSUMOS_PMF) {
      insumosPmfRef.current.checked = true;
    }

    if (roles.INSUMOS_RAPS) {
      insumosRapsRef.current.checked = true;
    }

    if (roles.INSUMOS_SRT) {
      insumosSrtRef.current.checked = true;
    }

    if (roles.MEDICAMENTOS) {
      medicamentosRef.current.checked = true;
    }
  }, [roles]);

  const setValue = (key, value) => {
    setValues({
      ...values,
      [key]: value
    });
  };

  const handleChange = e => {
    if (e.target.name === 'phone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (e.target.name === 'registration') {
      e.target.value = matriculaMask(e.target.value);
    }

    setValue(e.target.getAttribute('name'), e.target.value);
  };

  const handleCheck = e => {
    let newRoles = roles;
    newRoles[e.target.id] = e.target.checked;

    setRoles(newRoles);
  };

  const handleSubmit = e => {
    e.preventDefault();

    setLoading(true);

    const rolesArray = roles => Object.entries(roles).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(key);
      }

      return acc;
    }, []);

    const data = {
      _id: values._id,
      name: values.name,
      email: values.email.toLowerCase(),
      phone: values.phone,
      unit: values.unit,
      institution: values.institution,
      admissionDate: new Date(values.admissionDate),
      registration: values.registration,
      roles: rolesArray(roles)
    };

    editarUsuario(data);

    setLoading(false);

    history.push('/admin/usuarios');
  };

  const selectedUnit = unidades.some(item => item.unidade === values.unit) ? values.unit : '';

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div className={styles.logo}>
          <div>
            <img src={logoFesaude2} alt="Logo FeSaúde" />
          </div>
          <div>
            <h1 className={styles.title}>Editar Usuário</h1>
          </div>
        </div>
        <Form onSubmit={handleSubmit} noValidate>
          <div className={styles.form}>

          <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="institution">
                  <Form.Label>*Instituição:</Form.Label>
                  <Form.Select
                    autoComplete="nope"
                    className="border border-secondary"
                    required
                    name="institution"
                    onChange={handleChange}
                    value={values.institution}
                    disabled
                  >
                    <option value="" disabled>Selecione a Instituição</option>
                    {institutionSelect.map(item => (
                      <option key={item} value={item}>{item}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="registration">
                  <Form.Label>*Matrícula:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    required
                    className={styles.input}
                    type="text"
                    name="registration"
                    onChange={handleChange}
                    value={values.registration}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="name">
                  <Form.Label>*Nome:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="nope"
                    required
                    name="name"
                    onChange={handleChange}
                    value={values.name}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="email">
                  <Form.Label>*e-mail:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="email"
                    required
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="phone">
                  <Form.Label>*Telefone:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    className={styles.input}
                    type="text"
                    required
                    name="phone"
                    onChange={handleChange}
                    value={values.phone}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="admissionDate">
                  <Form.Label>*Data de admissão:</Form.Label>
                  <Form.Control
                    autoComplete="nope"
                    required
                    className={styles.input}
                    type="date"
                    name="admissionDate"
                    onChange={handleChange}
                    value={values.admissionDate}
                  />
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="unit">
                  <Form.Label>*Lotação:</Form.Label>
                  <Form.Select
                    autoComplete="nope"
                    className="border border-secondary"
                    required
                    name="unit"
                    onChange={handleChange}
                    value={selectedUnit}
                  >
                    <option value="" disabled>Selecione a lotação</option>
                    {unidades && unidades.map(item => (
                      <option key={item._id} value={item.unidade}>{item.unidade}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Label className='mt-4'>*Roles</Form.Label>
              </div>
                { roleGroups.map(group => (
                  <div className={styles.groupContainer} key={group.group}>
                    <span className={styles.groupTitle}>{group.group}</span>
                    { group.subgroups ? (
                      <div>
                        { group.subgroups.map(subgroup => (
                          <div className={styles.subgroupContainer} key={subgroup.title}>
                            <span className={styles.subgroupTitle}>{subgroup.title}</span>
                            <div className={styles.subgroupChecks}>
                              { subgroup.roles.map(role => (
                                <Form.Check
                                  key={role.name}
                                  label={role.name}
                                  name="roles"
                                  type="checkbox"
                                  id={role.name}
                                  value={role.name}
                                  onChange={handleCheck}
                                  ref={role.ref}
                                />
                              )) }
                            </div>
                          </div>
                        )) }
                      </div>
                    ) : (
                      <div className={styles.groupChecks}>
                        { group.roles.map(role => (
                          <Form.Check
                            key={role.name}
                            label={role.name}
                            name="roles"
                            type="checkbox"
                            id={role.name}
                            value={role.name}
                            onChange={handleCheck}
                            ref={role.ref}
                          />
                        )) }
                      </div>
                    ) }
                  </div>
                ))}
            </div>
          </div>

          <div className={styles.button}>
            {loading && (
              <Button variant="flat" disabled className={styles.btn} type="submit">
                Enviando...
              </Button>
            )}

            {!loading && (
              <Button variant="flat" className={styles.btn} type="submit">
                Enviar
              </Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Editar;
